var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackageBlu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0pack{fill:var(--primary);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0pack",
    d: "M8.5,5L8.2,5.4L5,9.7V27h22V9.7l-3.2-4.2L23.5,5H8.5z M9.5,7H15v2H8L9.5,7z M17,7h5.5L24,9h-7V7z M7,11h18v14H7 V11z M12.8,13c-0.6,0.1-1,0.5-0.9,1.1s0.5,1,1.1,0.9h6c0.4,0,0.7-0.2,0.9-0.5c0.2-0.3,0.2-0.7,0-1C19.7,13.2,19.4,13,19,13h-6 C13,13,12.9,13,12.8,13C12.9,13,12.8,13,12.8,13z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageBlu);
export default __webpack_public_path__ + "static/media/packageBlu.80eeb16a.svg";
export { ForwardRef as ReactComponent };